import { DASHBOARD } from '../actions/types';

const initialState = {
    data: null
};

export default (state = initialState, { type, payload }) => {
    switch (type) {
        case DASHBOARD.OBTENER:
            return { ...state, data: payload };
        default:
            return state;
    }
};
